module.exports = __webpack_public_path__ + "static/media/blog-placeholder.51a1f9b7.svg";